import $ from 'jquery';
import { spring } from "motion"
import Swiper from 'swiper/bundle';
import 'swiper/css';

window.$ = $;
window.Swiper = Swiper;


const HAMBURGER = {
    line1: { x1: 8, y1: 6,  x2: 24, y2: 6  },
    line2: { x1: 0, y1: 18, x2: 24, y2: 18 },
};
const X_SHAPE = {
    line1: { x1: 2, y1: 2,  x2: 22, y2: 22 },
    line2: { x1: 2, y1: 22, x2: 22, y2: 2  },
};

function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function morphHamburger(toX) {
    const lines = document.querySelectorAll('.hamburger svg line');
    const from = toX ? HAMBURGER : X_SHAPE;
    const to   = toX ? X_SHAPE   : HAMBURGER;
    const duration = 350;
    const start = performance.now();

    function step(now) {
        const t = Math.min((now - start) / duration, 1);
        const e = easeInOut(t);
        lines.forEach((line, i) => {
            const key = `line${i + 1}`;
            for (const attr of ['x1', 'y1', 'x2', 'y2']) {
                line.setAttribute(attr, from[key][attr] + (to[key][attr] - from[key][attr]) * e);
            }
        });
        if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
}

$('.hamburger').on('click', () => {
    const isActive = $('.nav-container').toggleClass('active').hasClass('active');
    morphHamburger(isActive);
});

$(document).on('click', '.nav-container nav ul li > a', function(e) {
    if (window.innerWidth > 991) return;
    const $li = $(this).parent();
    if (!$li.children('ul').length) return;
    e.preventDefault();
    $li.toggleClass('open').siblings('.open').removeClass('open');
});

$('footer button').on('click', function (optionsOrVisualDuration) {
    $('html, body').animate({ scrollTop: 0 }, optionsOrVisualDuration);
});

// Hysteresis: shrinking the header shifts the layout, so a single threshold would toggle endlessly
const $header = $('header.main');
$(window).on('scroll', () => {
    const y = $(window).scrollTop();
    if (y > 80) {
        $header.addClass('scrolled');
    } else if (y < 40) {
        $header.removeClass('scrolled');
    }
});